import React, {useState, useEffect} from 'react';
import Navbar from './components/Navbar';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import Restaurant from './components/pages/Restaurant';
import Footer from './components/Footer'
import Catering from './components/pages/Catering';
import Market from './components/pages/Market';
// import FAQs from "./components/pages/FAQs";
import MarketMenuCategory from './components/market_menu/MarketMenuCategory';
import { fetchCategories, createBasket, fetchBasket, handleAddToBasket, 
  handleUpdateBasketItemQuantity, handleRemoveFromBasket, handleEmptyBasket } from './lib/ShopifyUtility';
import Checkout from './components/pages/Checkout';
import MarketMenuItemDetailedWrapper from './components/MarketMenuItemDetailedWrapper';
// import Confirmation from './components/pages/Confirmation';

function App() {
  const [categories, setCategories] = useState([]);
  const [basketId, setBasketId] = useState(() => {
    // Load currentBasketId from localStorage if available
    return localStorage.getItem('basketId') || null;
  });
  const [basket, setBasket] = useState({});
  const [emptyingBasket, setEmptyingBasket] = useState(false)


    const initializeBasket = React.useCallback(async () => {
        let currentBasketId = basketId;

        // Try to fetch existing basket
        if (currentBasketId) {
            const fetchedBasket = await fetchBasket(currentBasketId);

            if (fetchedBasket) {
                setBasket(fetchedBasket);
                return currentBasketId;
            }
        }

        // Create new basket if none exists or fetch failed
        const newBasket = await createBasket();
        currentBasketId = newBasket.id;
        setBasketId(currentBasketId);
        localStorage.setItem('basketId', currentBasketId);
        setBasket(newBasket);

        return currentBasketId;
    }, [basketId]);

    const withValidBasket = async (actionFn) => {
        const validBasketId = await initializeBasket();
        await actionFn(validBasketId);
    };

    const refreshBasket = async (id) => {
        const basketData = await fetchBasket(id);
        setBasket(basketData);
    };

    const addToBasket = async (quantity, variantId) => {
        await withValidBasket(async (id) => {
            await handleAddToBasket(id, quantity, variantId);
            await refreshBasket(id);
        });
    };

    const updateItemBasketQuantity = async (itemId, quantity) => {
        await withValidBasket(async (id) => {
            await handleUpdateBasketItemQuantity(id, itemId, quantity);
            await refreshBasket(id);
        });
    };

    const removeFromBasket = async (itemId) => {
        await withValidBasket(async (id) => {
            await handleRemoveFromBasket(id, itemId);
            await refreshBasket(id);
        });
    };

    const emptyBasket = async () => {
        setEmptyingBasket(true);
        await withValidBasket(async (id) => {
            await handleEmptyBasket(id);
            await refreshBasket(id);
        });
        setEmptyingBasket(false);
    };

    useEffect(() => {
        const setup = async () => {
            const cat = await fetchCategories();
            setCategories(cat);

            await initializeBasket(); // ensures basket is created and fetched
        };

        setup();
    }, [initializeBasket]);



    return (
      <>
        <Navbar basket={basket} emptyBasket={emptyBasket} removeFromBasket={removeFromBasket} updateItemBasketQuantity={updateItemBasketQuantity} emptyingBasket={emptyingBasket}/>
        <Routes>
        <Route path='/' element={<Home />} />
        <Route path='restaurant' element={<Restaurant />} />
        <Route path='catering' element={<Catering />} />
        <Route path='market' element={<Market />} />
        {categories?.map((cat) => (
          <Route
            key={cat.id}
            path={'market/' + cat.handle}
            element={
              <MarketMenuCategory
                catHandle={cat.handle}
                catName={cat.title.toUpperCase()}
                onAddToBasket={addToBasket}
              />
            }
          />
        ))}
        <Route
          path='market/:catHandle/:itemHandle/*'
          element={<MarketMenuItemDetailedWrapper addToBasket = {addToBasket} />}
        />
        <Route
          path='checkout'
          element={
            <Checkout
              basket={basket}
              removeFromBasket={removeFromBasket}
              updateItemBasketQuantity={updateItemBasketQuantity}
            />
          }
        />
        {/*<Route*/}
        {/*  path='checkout/confirmation'*/}
        {/*  element={*/}
        {/*    <Confirmation*/}
        {/*      order={order}*/}
        {/*    />*/}
        {/*  }*/}
        {/*/>*/}
        {/*<Route path='market/faqs' element={<FAQs/>}/>*/}
      </Routes>
      <Footer />
    </>
  );
}

export default App;






